import {getRandomInt, isLocalStorageAvailable} from "../utils";

const LOCALSTORAGE_KEY = 'hpab_test_g';

export default class HiddenPricingABTest {
  constructor() {
    if (!!HiddenPricingABTest.instance) {
      return HiddenPricingABTest.instance;
    }

    HiddenPricingABTest.instance = this;

    if (!isLocalStorageAvailable()) return;

    // uncomment after test is finished
    // this.clearLocalStorage();

    this.sendEvent();
  }

  setupAB() {
    if (this.getGroup() === false) {
      this.setupGroup();
      this.sendEvent();
    }
  }

  sendEvent() {
    if (window.dataLayer && this.getGroup() !== false) {
      window.dataLayer.push({
        'event': 'GAEvent',
        'eventCategory': 'Hidden Pricing Test',
        'eventAction': this.getGroup()
      });

      window.dataLayer.push({
        hidden_pricing_test_variant: this.getGroup()
      });
    }
  }

  getGroup() {
    const group = window.localStorage.getItem(LOCALSTORAGE_KEY);

    return group ? group : false;
  }

  setupGroup() {
    let rand = getRandomInt(0,2);
    window.localStorage.setItem(LOCALSTORAGE_KEY, rand === 0 ? 'a' : (rand === 1) ? 'b' : 'c');
  }

  clearLocalStorage() {
    window.localStorage.removeItem(LOCALSTORAGE_KEY);
  }
}
